export const config = {
  Auth: {
    mandatorySignIn: true,
    region: process.env.REACT_APP_REGION,
    identityPoolId: process.env.REACT_APP_IDENTITY_POOL_ID_AD,
    userPoolId: process.env.REACT_APP_USER_POOL_ID_AD,
    userPoolWebClientId: process.env.REACT_APP_APP_CLIENT_ID_AD,
    oauth: {
      domain: process.env.REACT_APP_USER_POOL_DOMAIN_NAME,
      redirectSignIn: process.env.REACT_APP_REDIRECT_SIGNIN,
      redirectSignOut: process.env.REACT_APP_REDIRECT_SIGNOUT,
      responseType: process.env.REACT_APP_OAUTH_RESPONSE_TYPE,
      scope: ['email', 'profile', 'openid', 'aws.cognito.signin.user.admin']
    }
  },
  API: {
    endpoints: [
      {
        name: process.env.REACT_APP_API_NAME,
        endpoint: process.env.REACT_APP_URL_API,
        region: process.env.REACT_APP_REGION
      },
      {
        name: process.env.REACT_APP_CONVERTI_API_NAME,
        endpoint: process.env.REACT_APP_CONVERTI_URL_API,
        region: process.env.REACT_APP_REGION
      }
    ],
    xApiKey: process.env.REACT_APP_X_API_KEY
  }
};
